import { Link, createFileRoute } from '@tanstack/react-router'
import { MainLayout } from '~/components/layout/MainLayout'
import { getJobs, type JobListItem } from '~/lib/jobs'

export const Route = createFileRoute('/careers' as any)({
  loader: async () => {
    const jobs = await getJobs()
    return { jobs }
  },
  component: CareersPage,
})

function CareersPage() {
  const { jobs } = Route.useLoaderData() as { jobs: JobListItem[] }
  const sortedJobs = [...jobs].sort((a, b) => {
    const aDate = new Date(a.frontmatter.posted).getTime()
    const bDate = new Date(b.frontmatter.posted).getTime()
    return bDate - aDate
  })

  return (
    <MainLayout>
      <div className="min-h-screen w-full bg-white text-black">
        <div className="mx-auto max-w-5xl px-4 py-12 md:px-6 md:py-16">
          <header className="mb-10">
            <h1 className="text-3xl font-sans md:text-4xl">Careers at CoPlane</h1>
            <p className="mt-2 text-sm text-gray-600">
              Help us build the agentic orchestration platform for the enterprise.
            </p>
          </header>

          {sortedJobs.length === 0 ? (
            <div className="rounded border border-dashed border-gray-300 px-6 py-12 text-center">
              <h2 className="text-2xl font-sans">No open positions</h2>
              <p className="mt-2 text-sm text-gray-600">
                We&apos;re not hiring for new roles right now. Check back soon or reach out to{' '}
                <a href="mailto:founders@coplane.com" className="underline">
                  founders@coplane.com
                </a>
                .
              </p>
            </div>
          ) : (
            <ul className="space-y-6">
              {sortedJobs.map((job) => (
                <li key={job.slug} className="border-b border-gray-200 pb-6">
                  <div className="flex flex-wrap items-center justify-between gap-4">
                    <h2 className="text-xl font-sans md:text-2xl">
                      <Link
                        to="/careers/$slug"
                        params={{ slug: job.slug }}
                        className="hover:underline"
                      >
                        {job.frontmatter.title}
                      </Link>
                    </h2>
                    <Link
                      to="/careers/$slug"
                      params={{ slug: job.slug }}
                      className="text-xs font-semibold uppercase tracking-wide text-gray-700"
                    >
                      View role →
                    </Link>
                  </div>

                  {job.excerpt && (
                    <p className="mt-3 text-sm text-gray-800">{job.excerpt}</p>
                  )}

                  <dl className="mt-4 grid gap-2 text-xs text-gray-600 sm:grid-cols-2">
                    <div className="flex gap-2">
                      <dt className="font-semibold">Department:</dt>
                      <dd>{job.frontmatter.department}</dd>
                    </div>
                    <div className="flex gap-2">
                      <dt className="font-semibold">Location:</dt>
                      <dd>{job.frontmatter.location}</dd>
                    </div>
                    <div className="flex gap-2">
                      <dt className="font-semibold">Type:</dt>
                      <dd>{job.frontmatter.type}</dd>
                    </div>
                    <div className="flex gap-2">
                      <dt className="font-semibold">Experience:</dt>
                      <dd>{job.frontmatter.experience}</dd>
                    </div>
                  </dl>
                </li>
              ))}
            </ul>
          )}
        </div>
      </div>
    </MainLayout>
  )
}
